import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { deleteAnalystConversation, fetchAnalystConversations } from '@/api/analyst';

// Remove snapshots written by the former client-backed history store.
try {
  window.localStorage.removeItem('sesame-analyst-sessions');
} catch {
  // Storage can be unavailable in restricted browser contexts.
}

const useChatHistoryStore = create()(
  immer(() => ({
    sessions: [],
    isLoading: false,
    error: null,
  })),
);

const { setState: set } = useChatHistoryStore;

const formatRelativeTime = value => {
  const timestamp = new Date(value).getTime();
  const delta = (Date.now() - timestamp) / 1000;
  if (delta < 3600) return `${Math.max(0, Math.round(delta / 60))}m ago`;
  if (delta < 86400) return `${Math.round(delta / 3600)}h ago`;
  if (delta < 604800) return `${Math.round(delta / 86400)}d ago`;
  return new Date(timestamp).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};

export const chatHistoryActions = {
  fetch: async () => {
    set(s => {
      s.isLoading = true;
      s.error = null;
    });
    try {
      const data = await fetchAnalystConversations();
      set(s => {
        s.sessions = data.results ?? [];
        s.isLoading = false;
      });
    } catch (error) {
      set(s => {
        s.isLoading = false;
        s.error = error;
      });
      throw error;
    }
  },

  delete: async id => {
    try {
      await deleteAnalystConversation(id);
      set(s => {
        s.sessions = s.sessions.filter(session => session.id !== id);
      });
      return true;
    } catch (error) {
      set(s => {
        s.error = error;
      });
      return false;
    }
  },

  formatRelativeTime,
};

export default useChatHistoryStore;
